import type { RuleHandler } from "../types";
import { setIncludes } from "utilities/promotions/setIncludes";

const checkExcludedSeasonIds: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  return !setIncludes(
    new Set(requirementAttributes?.excludedSeasonIds),
    new Set(context.selection.seasonIds),
  );
};

export { checkExcludedSeasonIds };
